
import { useStoreLayout } from "features/layout/store";
import { useQueryMsal } from "./data";


export const useLayout = () => {
	const layout = useStoreLayout();

	const redirect = "/";
	return { ...layout, redirect };
};

export const useLayoutMsal = useQueryMsal;